<div class="start-a-community-page">
  <section class="hero-section">
    <div class="container">
      <div class="row align-items-center g-4 g-lg-5">
        <div class="col-lg-6 order-2 order-lg-1">
          <div class="hero-content">
            <h1 class="headline mt-primary-text mb-3">Start a professional community</h1>
            <p class="subheadline mb-4">
              Launch a member-based network for your profession, city, or niche with the tools to manage memberships, events, directories, and growth from day one—including a branded member experience on the web and in the <a routerLink="/mobile" class="inline-link">MemberTrace mobile app</a>.
            </p>
            <div class="cta-buttons">
              <button mat-flat-button color="primary" routerLink="/register-organization">Start your community</button>
              <button mat-stroked-button color="primary" routerLink="/contact">Talk to our team</button>
            </div>
          </div>
        </div>
        <div class="col-lg-6 order-1 order-lg-2">
          <div class="hero-visual-strip">
            <img src="/img/dashboard.webp?v=1" alt="Launch your community with MemberTrace" onerror="this.style.display='none'; this.nextElementSibling?.classList.add('show');" />
            <div class="hero-visual-placeholder" aria-hidden="true"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="founders-section py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center">
          <h2 class="section-title">Built for community founders like you</h2>
          <p class="section-intro mb-0">Whether you're launching a physician network, a local professional group, or a new membership community, MemberTrace gives you the structure to build with confidence.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="launch-capabilities-section py-5">
    <div class="container">
      <h2 class="section-title text-center mb-5">Everything you need to launch and grow</h2>
      <div class="row g-4">
        <div class="col-md-6 col-lg-4" *ngFor="let item of launchCapabilities">
          <div class="capability-card">
            <mat-icon color="primary" class="capability-icon">{{ item.icon }}</mat-icon>
            <h3 class="capability-title">{{ item.title }}</h3>
            <p class="capability-desc">{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="playbook-section py-5">
    <div class="container">
      <h2 class="section-title text-center mb-5">How to start your community</h2>
      <div class="steps-timeline">
        <div class="step-item" *ngFor="let step of launchSteps; let i = index">
          <span class="step-number">{{ i + 1 }}</span>
          <p class="step-label">{{ step }}</p>
        </div>
      </div>
    </div>
  </section>

  <section class="examples-section py-5">
    <div class="container">
      <h2 class="section-title text-center mb-5">Communities you can build with MemberTrace</h2>
      <div class="community-chips">
        <span class="chip" *ngFor="let name of exampleCommunities">{{ name }}</span>
      </div>
    </div>
  </section>

  <section class="structure-split-section py-5">
    <div class="container">
      <div class="row align-items-center g-4 g-lg-5">
        <div class="col-lg-6 order-2 order-lg-1">
          <h2 class="section-title mb-3">Why starting with structure matters</h2>
          <p class="section-intro mb-0">Many communities begin with spreadsheets, group chats, and scattered event tools. MemberTrace gives you one place to manage members, events, directories, payments, and future growth—so you can build momentum without patching systems together.</p>
        </div>
        <div class="col-lg-6 order-1 order-lg-2">
          <div class="structure-visual">
            <img src="/img/dashboard-2.webp" alt="MemberTrace community dashboard" onerror="this.style.display='none'; this.nextElementSibling?.classList.add('show');" />
            <div class="structure-visual-placeholder" aria-hidden="true"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="cta-section py-5">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <h2 class="cta-title mb-3">Launch your community with the right structure from day one</h2>
          <p class="cta-subtitle mb-4">MemberTrace gives you the tools to bring members together and grow with confidence.</p>
          <div class="cta-buttons d-flex flex-wrap gap-3 justify-content-center">
            <button mat-flat-button color="primary" routerLink="/register-organization">Start your community</button>
            <button mat-stroked-button color="primary" routerLink="/contact">Talk to our team</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
